/**
 * Clickable Teaser Module
 *
 * @module ClickableTeaser
 * @author EN GARDE
 * @version 1.0
 *
 * @requires jQuery
 *
 * change log:
 * 	1.0		initial version
 */

var EN = EN || {};

EN.ClickableTeaser = (function(_, $) {
  "use strict";

  var options = {
    classNames: {
      container: "en-clickable-teaser",
    },
  };

  var init = function(settings) {
    options = _.defaultsDeep(settings, options);

    var selector = "." + options.classNames.container + ":has(a[href])";
    var clickableTeaser = document.querySelectorAll(selector);

    clickableTeaser.forEach(function(teaser) {
      var link = teaser.querySelector("a");
      if (link && link.href) {
        teaser.style.cursor = "pointer"; // Change the cursor to pointer when hovering
        teaser.addEventListener("click", function(event) {
          // Prevent default behavior if the target of the click is the link itself
          if (event.target !== link) {
            link.click(); // Trigger the link click event
          }
        });
      }
    });
  };

  // exports
  return {
    init: init,
  };
})(lodash, jQuery);
